import React from 'react';
import { FlameIcon, MessageCircleIcon, ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_PRICE, formatPrice } from '../data/config';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type FinalCTAProps = {
  guaranteeEnabled: boolean;
};
export function FinalCTA({
  guaranteeEnabled
}: FinalCTAProps) {
  return <section className="bg-navy px-4 py-6 text-center md:px-12 md:py-7" data-id="element-38" data-mp="87js0fnfcgiv">
      <h2 className="font-heading text-[24px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-gold md:text-[29px]" data-id="element-39" data-mp="m3dry967zvju">
        One last question
      </h2>
      <p className="mx-auto mt-1.5 max-w-[560px] text-[14px] leading-[1.37] text-white md:text-[15px]" data-id="element-40" data-mp="vv1djtg3iide">
        How many times have you prepared for a speech therapy session and ended up searching for pictures, word lists,
        exercises, or activities across multiple resources? You can keep gathering materials from different places
        every time you need to work on a specific therapy goal. Or you can have an organized collection of
        articulation, receptive language, expressive language, and social communication activities, along with
        printable cards, games, home practice resources, and professional tracking tools.
      </p>
      <p className="mt-1.5 font-heading text-[13px] font-extrabold uppercase text-gold md:text-[14px]" data-id="element-41" data-mp="2m571c95hljwk">
        Organize. Select. Apply. Support.
      </p>

      <div className="mx-auto mt-3 max-w-[180px]" data-id="element-42" data-mp="2v2ha9nuu0wyb">
        <ProductImage data-id="element-43" data-mp="302lw7teiejvx" />
      </div>

      <h3 className="mx-auto mt-2 max-w-[600px] font-heading text-[21px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-white md:text-[28px]" data-id="element-44" data-mp="301u26n0k8u7r">
        <MessageCircleIcon className="mr-1.5 inline h-6 w-6 -translate-y-0.5 text-gold" strokeWidth={2.5} aria-hidden data-id="element-45" data-mp="34vohzfd1op1k" />
        Complete Speech Therapy Activities Bundle™
      </h3>
      <p className="mx-auto mt-1 max-w-[600px] font-heading text-[11px] font-bold uppercase leading-tight text-white md:text-[12px]" data-id="element-46" data-mp="3epf104qek79v">
        The complete activity collection for speech-language professionals
      </p>
      <p className="mt-1 text-[13px] leading-[1.35] text-[#CFE6F7] md:text-[14px]" data-id="element-47" data-mp="1ep8qdrqifa8b">
        Articulation • Receptive Language • Expressive Language • Social Communication
      </p>
      <p className="mt-1 font-heading text-[11px] font-bold uppercase text-white/80 md:text-[12px]" data-id="element-48" data-mp="1sirm960ankrs">
        4 main volumes + 4 free professional bonuses
      </p>
      <p className="mt-2 flex flex-wrap items-center justify-center gap-1.5 font-heading text-[14px] font-extrabold uppercase leading-tight text-gold md:text-[16px]" data-id="element-49" data-mp="22drv5xacp4vn">
        <FlameIcon className="h-4 w-4 shrink-0" strokeWidth={2.5} aria-hidden data-id="element-50" data-mp="2bf9avejuj4jt" />
        Get the complete bundle today for {formatPrice(PRODUCT_PRICE)} USD!
      </p>
      <div className="mt-2" data-id="element-51" data-mp="27btg6nrc7e9r">
        <CtaButton mode="checkout" subtext="Instant Digital Access • Digital Delivery" data-id="element-52" data-mp="h18c0toaqhjq">
          Get instant access
        </CtaButton>
      </div>
      {guaranteeEnabled && <p className="mx-auto mt-2.5 max-w-[440px] font-heading text-[11px] font-bold uppercase leading-snug text-white md:text-[12px]" data-id="element-53" data-mp="d29dprx2lj19">
          <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-brand" aria-hidden data-id="element-54" data-mp="6xtacdn4q31v" />
          7-day money-back guarantee • 4 volumes + 4 free bonuses
        </p>}
    </section>;
}